import { ICheckPublishTermSchema } from '../../../../../repositories/monolith-python/entities/CheckPublishTermSchema';
import { IPublishOption, IPublishTermsService } from '../../../../reducers';

export function mapPublishTerm(
  publishTerm: IPublishOption,
  selectedService: IPublishTermsService,
): ICheckPublishTermSchema {
  const { type, days, tariffIdentificator } = publishTerm;
  const { services } = selectedService;

  return {
    type,
    days,
    tariffIdentificator,
    services,
  };
}
